import { configureStore } from '@reduxjs/toolkit';
import { config } from '../config/env';
import rootReducer from './reducers';

const initializeStore = () => {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState: {},
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: false,
        serializableCheck: !config.isProduction,
        immutableCheck: !config.isProduction,
      }),
    devTools: !config.isProduction,
  });

  return store;
};

export default initializeStore;
